export enum EnActivityMode {
    CarePlan = 'careplan',
    Extra = 'extra',
}
